import { cn } from "@/lib/utils";
import { ToggleGroupItem } from "@radix-ui/react-toggle-group";

interface TechItemPRops {
  value: string;
  label: string;
  src: string | React.ReactNode;
  disabledReason?: string;
}

export function TechItem({ value, label, src, disabledReason }: TechItemPRops) {
  return (
    <ToggleGroupItem
      value={value}
      disabled={Boolean(disabledReason)}
      data-tooltip-id="tooltip"
      data-tooltip-content={disabledReason || label}
      aria-label={label}
      className={cn(
        "cursor-pointer transition-opacity duration-200 w-7 aspect-square rounded-md flex items-center justify-center",
        "hover:opacity-70 opacity-10 data-[state=on]:opacity-100 data-[state=on]:bg-secondary-300",
        disabledReason && "opacity-10! cursor-not-allowed!",
      )}
    >
      {typeof src === "string" ? (
        <img src={src} alt={label} className="w-5 aspect-square" />
      ) : (
        <span className="*:w-5 *:aspect-square">{src}</span>
      )}
    </ToggleGroupItem>
  );
}
